import { render, staticRenderFns } from "./LKMenuDropDown.vue?vue&type=template&id=89b10a4e&scoped=true&"
import script from "./LKMenuDropDown.vue?vue&type=script&lang=js&"
export * from "./LKMenuDropDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89b10a4e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
installComponents(component, {VBadge})
